import React, { useEffect, useState } from "react";
import { css } from "@emotion/react";
import { Common } from "@src/styles/Common";
import AWS from "aws-sdk";
import ServerChart from "@src/components/chart/ServerChart";

function EC2StatsChart() {
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_BACKEND_USER_ACCESS_KEY,
        secretAccessKey:
            process.env.REACT_APP_AWS_BACKEND_USER_ACCESS_SECRET_KEY,
    });

    const [lastTimestamp, setLastTimestamp] = useState("");
    const [timePeriodType, setTimePeriodType] = useState(0);
    const [timePeriod, setTimePeriod] = useState(1000 * 60 * 60 * 3);
    const [timeInterval, setTimeInterval] = useState(500);
    const [chartData, setChartData] = useState([] as any);

    const createOption = (data: any) => {
        const colors = [
            "#F5E9CF",
            "#7DB9B6",
            "#FFB84C",
            "#A459D1",
            "#4D455D",
            "#34c9c1",
            "#E96479",
        ];
        const labels = data?.map((el: any) => el.Id);
        const times = data?.map((el: any) => el.Timestamps);
        const dataList = data?.map((el: any) => el.Values);

        return {
            labels: times[0],
            datasets: dataList.map((el: any, idx: number) => {
                return {
                    type: "line",
                    label: labels[idx],
                    data: el,
                    borderColor: colors[idx],
                    backgroundColor: colors[idx],
                    borderWidth: 2,
                    pointRadius: 2,
                    pointHoverBackgroundColor: Common.colors.white,
                    pointHoverBorderWidth: 3,
                    pointHoverRadius: 3,
                };
            }),
        };
    };

    useEffect(() => {
        const timerId = setInterval(() => {
            AWS.config.update({
                region: "ap-northeast-2",
            });
            const cw = new AWS.CloudWatch({ apiVersion: "2010-08-01" });
            const today = new Date();
            const params = {
                StartTime: new Date(today.getTime() - timePeriod),
                EndTime: today,
                MetricDataQueries: [
                    {
                        Id: "webServer",
                        Label: "CPUUtilization",
                        MetricStat: {
                            Metric: {
                                Namespace: "AWS/EC2",
                                MetricName: "CPUUtilization",
                                Dimensions: [
                                    {
                                        Name: "InstanceId",
                                        Value: "i-0c08f25e964dd1d5d",
                                    },
                                ],
                            },
                            Period: 600,
                            Stat: "Average",
                            Unit: "Percent",
                        },
                    },
                    {
                        Id: "deungiServer",
                        Label: "CPUUtilization",
                        MetricStat: {
                            Metric: {
                                Namespace: "AWS/EC2",
                                MetricName: "CPUUtilization",
                                Dimensions: [
                                    {
                                        Name: "InstanceId",
                                        Value: "i-080016ca5fa0bf491",
                                    },
                                ],
                            },
                            Period: 600,
                            Stat: "Average",
                            Unit: "Percent",
                        },
                    },
                    {
                        Id: "schedulerServer",
                        Label: "CPUUtilization",
                        MetricStat: {
                            Metric: {
                                Namespace: "AWS/EC2",
                                MetricName: "CPUUtilization",
                                Dimensions: [
                                    {
                                        Name: "InstanceId",
                                        Value: "i-0f2c3e3c15dc859f8",
                                    },
                                ],
                            },
                            Period: 600,
                            Stat: "Average",
                            Unit: "Percent",
                        },
                    },
                    {
                        Id: "crawlerServer",
                        Label: "CPUUtilization",
                        MetricStat: {
                            Metric: {
                                Namespace: "AWS/EC2",
                                MetricName: "CPUUtilization",
                                Dimensions: [
                                    {
                                        Name: "InstanceId",
                                        Value: "i-0a303a07350e316c9",
                                    },
                                ],
                            },
                            Period: 600,
                            Stat: "Average",
                            Unit: "Percent",
                        },
                    },
                    {
                        Id: "itemsDBServer",
                        Label: "CPUUtilization",
                        MetricStat: {
                            Metric: {
                                Namespace: "AWS/EC2",
                                MetricName: "CPUUtilization",
                                Dimensions: [
                                    {
                                        Name: "InstanceId",
                                        Value: "i-06c61dd8736acf30e",
                                    },
                                ],
                            },
                            Period: 600,
                            Stat: "Average",
                            Unit: "Percent",
                        },
                    },
                    {
                        Id: "apiServer",
                        Label: "CPUUtilization",
                        MetricStat: {
                            Metric: {
                                Namespace: "AWS/ECS",
                                MetricName: "CPUUtilization",
                                Dimensions: [
                                    {
                                        Name: "ClusterName",
                                        Value: "AppApi-Live-Clu",
                                    },
                                    {
                                        Name: "ServiceName",
                                        Value: "AppApi-Live",
                                    },
                                ],
                            },
                            Period: 600,
                            Stat: "Average",
                            Unit: "Percent",
                        },
                    },
                    {
                        Id: "adminServer",
                        Label: "CPUUtilization",
                        MetricStat: {
                            Metric: {
                                Namespace: "AWS/ECS",
                                MetricName: "CPUUtilization",
                                Dimensions: [
                                    {
                                        Name: "ClusterName",
                                        Value: "AppApi-Live-Clu",
                                    },
                                    {
                                        Name: "ServiceName",
                                        Value: "AdminApi-Live",
                                    },
                                ],
                            },
                            Period: 600,
                            Stat: "Average",
                            Unit: "Percent",
                        },
                    },
                ],
            };

            cw.getMetricData(params, (err, data) => {
                setChartData(createOption(data.MetricDataResults));
                setLastTimestamp(
                    new Date(new Date().getTime() + 32400000)
                        .toISOString()
                        .replace("T", " ")
                        .split(".")[0],
                );
                setTimeInterval(300 * 1000);
            });
        }, timeInterval);

        return () => clearInterval(timerId);
    }, [timeInterval]);

    const setTimeType = (type: number) => {
        setTimeInterval(500);
        setTimePeriodType(type);

        switch (type) {
            case 0:
                setTimePeriod(1000 * 60 * 60 * 3);
                break;
            case 1:
                setTimePeriod(1000 * 60 * 60 * 24);
                break;
            case 2:
                setTimePeriod(1000 * 60 * 60 * 24 * 3);
                break;
        }
    };
    return (
        <div css={subChartDiv}>
            <p css={titleP}>서버 현황 - CPU Utilization ({lastTimestamp})</p>
            <div id="loading-root"></div>
            <div css={btnBox}>
                <button
                    className={timePeriodType === 0 ? "active" : ""}
                    onClick={(e) => {
                        setTimeType(0);
                    }}
                >
                    3시간
                </button>
                <button
                    className={timePeriodType === 1 ? "active" : ""}
                    onClick={(e) => {
                        setTimeType(1);
                    }}
                >
                    1일
                </button>
                <button
                    className={timePeriodType === 2 ? "active" : ""}
                    onClick={(e) => {
                        setTimeType(2);
                    }}
                >
                    3일
                </button>
            </div>
            <div className="mainChartBox">
                <ServerChart data={chartData} max={100} />
            </div>
        </div>
    );
}

const btnBox = css`
    position: absolute;
    top: 13px;
    right: 20px;

    button {
        padding: 3px 5px;
        margin-left: 5px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 3px;
        cursor: pointer;

        &.active {
            border: 1px solid #9a49f2;
            color: #9a49f2;
        }
    }
`;

const subChartDiv = css`
    position: relative;
    height: fit-content;
    max-height: 450px;
    canvas {
        height: 330px !important;
    }
`;
const titleP = css`
    ${Common.textStyle.title7_M12}
    color: ${Common.colors.black};
    margin-bottom: 12px;
`;

export default EC2StatsChart;
